import Carousel from "./Carousel.react";

export default Carousel;
